import Kfit from 'integrations/Kfit';

export default (id, params) =>
  Kfit.patch(`/v8/companies/${id}/company_profiles/claim_starter_kit`, params);
